import React, { Component } from 'react';

class Cartera extends Component {
    constructor(props) {
        super(props);
    }
    
    render() {
        const { props } = this;

        return (
            <div className="row">
                <div className="col-xs-12">
                    <div>
                        <label className="label-primary">Cartera</label>
                    </div>
                    <div>
                        <label className="label-secondary">{props.carteraDescripcion}</label>
                    </div>
                </div>
            </div>

        );
    }
}

export default Cartera;